import {
  Box,
  Button,
  Card,
  Chip,
  Container,
  Divider,
  IconButton,
  InputAdornment,
  ListItem,
  ListItemButton,
  ListItemText,
  Menu,
  MenuItem,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
  useTheme
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BuildIcon from "@mui/icons-material/Build";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import { Postrequestcall } from "../../request/Postrequest";
import { FETCH_TRADES, FETCH_UNIVERSAL_SEARCH, GET_USER_ADDRESS } from "../../constant/Apipath";
import { useSelector } from "react-redux";
import { MoreVert as MoreIcon } from "@mui/icons-material";
import Loader from "../../common/Loader";
import { Autocomplete as GooglePlacesAutocomplete } from "@react-google-maps/api";
import { Close as CloseIcon } from "@mui/icons-material";
import { BIBlue, BIYellow } from "../../assets/helpers";
import { Getrequestcall } from "../../request/Getrequest";
import { BIRed } from "../../assets/helpers";
import { setLocationForGlobalSearch, setShowReport } from "../../redux/actions/actions";
import { useDispatch } from "react-redux";
import { English } from "../../constant/EnglishFallback";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import Emptydata from "../common/Emptydata";
import { debounce } from "lodash";
import Pages from "../../constant/ReportModel";

const Search = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const { loginData, globalSearchLocation, multiLanguageData } = useSelector(
    (state) => state?.main
  );
  const currentUserId = loginData?.userInformation?.UserId ?? 0;
  const searchTerm = location?.state?.searchTerm ?? "";

  const LanguageData = multiLanguageData?.GlobalSearch || {};
  const {
    TEXT_TYPE = English.GlobalSearch.TEXT_TYPE,
    TEXT_COMPANIES = English.GlobalSearch.TEXT_COMPANIES,
    TEXT_MANUFACTURERS = English.GlobalSearch.TEXT_MANUFACTURERS,
    TEXT_PRODUCTS = English.GlobalSearch.TEXT_PRODUCTS,
    TEXT_TRADES = English.GlobalSearch.TEXT_TRADES,
    TEXT_SITES = English.GlobalSearch.TEXT_SITES,
    TEXT_PROJECTS = English.GlobalSearch.TEXT_PROJECTS,
    TEXT_ADVANCED = English.GlobalSearch.TEXT_ADVANCED,
    BUTTON_SHOW_MORE = English.GlobalSearch.BUTTON_SHOW_MORE,
    TEXT_LOCATION_TYPE_HERE_PLACEHOLDER = English.GlobalSearch.TEXT_LOCATION_TYPE_HERE_PLACEHOLDER,
    TEXT_QUICK_LOCATION = English.GlobalSearch.TEXT_QUICK_LOCATION,
    TEXT_SHOW_LESS_TRADES = English.GlobalSearch.TEXT_SHOW_LESS_TRADES,
    TEXT_SHOW_MORE_TRADES = English.GlobalSearch.TEXT_SHOW_MORE_TRADES,
    BUTTON_REPORT = English.GlobalSearch.BUTTON_REPORT,
    TEXT_NO_RESULTS_FOUND = English.GlobalSearch.TEXT_NO_RESULTS_FOUND
  } = LanguageData || {};

  const [displayedTradeCount, setDisplayedTradeCount] = useState(0);
  const [initialViewMore, setInitialViewMore] = useState(true);
  const [autocomplete, setAutocomplete] = useState(null);
  const [address, setAddress] = useState("");
  const [selectCity, setSelectCity] = useState(globalSearchLocation ?? []);
  const [userCity, setUserCity] = useState({ city: "", checked: false });
  const [tradeList, setTradeList] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [showTradeLoading, setShowTradeLoading] = useState(false);
  const [isExpanded, setIsExpanded] = useState(true);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const [data, setData] = useState({
    company: [],
    manufacture: [],
    product: [],
    trade: [],
    sites: [],
    projects: []
  });

  const [typeList, setTypeList] = useState([
    { text: TEXT_COMPANIES, checked: false, itemRecordType: "company" },
    { text: TEXT_MANUFACTURERS, checked: false, itemRecordType: "manufacturer" },
    { text: TEXT_PRODUCTS, checked: false, itemRecordType: "product" },
    { text: TEXT_TRADES, checked: false, itemRecordType: "trade" },
    { text: TEXT_SITES, checked: false, itemRecordType: "site" },
    { text: TEXT_PROJECTS, checked: false, itemRecordType: "project" }
  ]);

  useEffect(() => {
    if (searchTerm) {
      fetchInitialSearchData();
    } else {
      fetchOnlyUserLocation(); // skip getData when no searchTerm
    }
  }, [searchTerm]);

  useEffect(() => {
    return () => {
      debouncedGetInitialData.flush();
    };
  }, []);

  const fetchInitialSearchData = async () => {
    try {
      setShowTradeLoading(true);
      await getTradeList();
      const userAddress = await getUserAddress();
      const cityObj = { city: userAddress?.city, checked: false };
      setUserCity(cityObj);
      await getInitialData(typeList, [cityObj], tradeList);
    } catch (error) {
      console.error(
        "fetchInitialSearchData-> Error When Getting User Address/Initial Data: ",
        error
      );
    } finally {
      setShowTradeLoading(false);
    }
  };

  const fetchOnlyUserLocation = async () => {
    try {
      setShowTradeLoading(true);
      await getTradeList();
      const userAddress = await getUserAddress();
      const cityObj = { city: userAddress?.city, checked: false };
      setUserCity(cityObj);
    } catch (error) {
      console.error("fetchOnlyUserLocation-> Error When Trying To Get User Address: ", error);
    } finally {
      setShowTradeLoading(false);
    }
  };

  const getUserAddress = async () => {
    try {
      const res = await Getrequestcall(
        `${GET_USER_ADDRESS}/${currentUserId}`,
        loginData?.accessToken
      );
      return res?.data?.data;
    } catch (error) {
      console.log("fetchOnlyUserLocation-> Error When Trying To Get User Address: ", error);
    }
  };

  const getSearchValues = (list, key) => {
    return list
      .filter((item) => item.checked)
      .map((item) => item[key])
      .join(",");
  };

  const getInitialData = async (typeList, selectCity, tradeList) => {
    const searchType = getSearchValues(typeList, "itemRecordType");
    const searchLocation = getSearchValues(selectCity, "city");
    const searchTrades = getSearchValues(tradeList, "id");
    getData(searchType, searchLocation, searchTrades);
  };

  const debouncedGetInitialData = useRef(
    debounce((typeList, selectCity, tradeList) => {
      getInitialData(typeList, selectCity, tradeList);
    }, 500) // 500ms delay, adjust as needed
  ).current;

  const getData = async (searchType, searchLocation, searchTrade) => {
    try {
      setLoading(true);
      let obj = {
        UserId: Number(currentUserId),
        SearchString: searchTerm,
        SearchType: searchType?.trim() ?? "",
        SearchLocations: searchLocation?.trim() ?? "",
        SearchTrades: searchTrade?.trim() ?? "",
        PageNumber: 1,
        NrRowsPerPage: 20
      };

      let res = await Postrequestcall(FETCH_UNIVERSAL_SEARCH, obj, loginData?.accessToken);
      let resData = res?.data?.data ?? [];

      const segregatedData = resData.reduce(
        (acc, item) => {
          if (item.type === "Companies") acc.company.push(item);
          if (item.type === "Manufacturers") acc.manufacture.push(item);
          if (item.type === "Products") acc.product.push(item);
          if (item.type === "Trades") acc.trade.push(item);
          if (item.type === "Sites") acc.sites.push(item);
          if (item.type === "Projects") acc.projects.push(item);
          return acc;
        },
        { company: [], manufacture: [], product: [], trade: [], sites: [], projects: [] }
      );
      setData(segregatedData);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("getData-> Error When Fetching Usersal Search Data: ", error);
    }
  };

  const isGlobalSearchDataEmpty = () => {
    return (
      data?.company.length === 0 &&
      data?.manufacture.length === 0 &&
      data?.product.length === 0 &&
      data?.trade.length === 0 &&
      data?.sites.length === 0 &&
      data?.projects.length === 0
    );
  };

  const getTradeList = async () => {
    try {
      const obj = {
        PageNr: 1,
        FullSearch: "",
        IncludeRecordNr: true,
        TypeOfObjectReturned: "NameOnly",
        SearchList: [{}],
        NrOfRecPerPage: 0
      };
      const res = await Postrequestcall(FETCH_TRADES, obj, loginData?.accessToken);
      const resData = res?.data?.data ?? [];
      const updatedData = resData.map((item) => ({ ...item, selected: false }));
      setDisplayedTradeCount(10);
      setTradeList(updatedData);
    } catch (error) {
      console.error("getTradeList-> Error While Fetching Trade: ", error);
    }
  };

  const handleSearch = () => {
    const place = autocomplete.getPlace();
    if (place?.address_components) {
      const getCity = place?.address_components.find((address) =>
        address.types.includes("locality")
      )?.long_name;
      const getCountry = place?.address_components.find((address) =>
        address.types.includes("country")
      )?.long_name;
      const location = getCity || getCountry;
      if (location) {
        // Check if location already exists in selectCity or matches userCity
        const isDuplicate =
          selectCity.some((city) => city.city === location) || userCity.city === location;

        if (!isDuplicate) {
          const newCities = [{ city: location, checked: false }, ...selectCity];
          setSelectCity(newCities);
          dispatch(
            setLocationForGlobalSearch(newCities?.map((item) => ({ ...item, checked: false }))) ??
              []
          );
        }
      }
      setAddress(place.formatted_address);
    }
  };

  const onTypeChange = async (index) => {
    let typeListClone = await [...typeList]?.map((item, i) =>
      i === index ? { ...item, checked: !item?.checked } : item
    );
    setTypeList(typeListClone);
    debouncedGetInitialData(typeListClone, selectCity, tradeList);
  };

  const onTradeClick = async (index) => {
    let tradeListClone = await [...tradeList]?.map((item, i) =>
      i === index ? { ...item, checked: !item?.checked } : item
    );
    setTradeList(tradeListClone);
    debouncedGetInitialData(typeList, selectCity, tradeListClone);
  };

  const onCityClick = async (index) => {
    setAddress("");
    let cityListClone = await [...selectCity]?.map((item, i) =>
      i === index ? { ...item, checked: !item?.checked } : item
    );
    setSelectCity(cityListClone);
    debouncedGetInitialData(typeList, cityListClone, tradeList);
  };

  const onCurrentCityClick = async () => {
    const cityClone = [
      ...selectCity,
      {
        city: userCity?.city,
        checked: !userCity?.checked
      }
    ];
    setUserCity((preValue) => ({
      ...preValue,
      checked: !preValue?.checked
    }));
    debouncedGetInitialData(typeList, cityClone, tradeList);
  };

  const onShowMoreClick = (type) => {
    let url = "";
    if (type === "product") {
      url = "/products";
    } else if (type === "manufacturer") {
      url = "/manufactures";
    } else if (type === "company") {
      url = "/companies";
    } else if (type === "trade") {
      url = "/trades";
    } else if (type === "sites") {
      url = "/sites";
    } else {
      url = null;
    }

    if (!url) return null;

    navigate(url, {
      state: {
        searchTerm
      }
    });
  };

  const onItemClick = (type, item) => {
    let url = "";
    if (type === "product") {
      url = "/product";
    } else if (type === "manufacturer") {
      url = "/manufacture";
    } else if (type === "company") {
      url = "/company";
    } else if (type === "trade") {
      url = "/trade";
    } else if (type === "sites") {
      url = "/sites";
    }else if (type === "projects") {
      url = "/project";
    } 
     else {
      url = null;
    }
    if (!url) return null;
    if (type === "sites") {
      navigate("/sites", {
        state: {
          site: {
            siteId:item?.recordId,
          }
        }
      });
    } else {
      navigate(`${url}/${item?.recordId}`);
    }
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedItem(null);
  };

  let nameForReport = "";
  switch (selectedItem?.type) {
    case "Products":
      nameForReport = Pages?.product?.name || "Products";
      break;
    case "Manufacturers":
      nameForReport = Pages?.manufacturers?.name || "Manufacturers";
      break;
    case "Companies":
      nameForReport = Pages?.companies?.name || "Companies";
      break;
    case "Trades":
      nameForReport = Pages?.trades?.name || "Trades";
      break;
    case "Sites":
      nameForReport = Pages?.site?.name || "Sites";
      break;
    case "Projects":
      nameForReport = Pages?.projects?.name || "Projects";
      break;
    default:
      nameForReport = "";
  }

  const handleReportClick = () => {
    handleMenuClose();
    let reportObj = {
      showReport: true,
      name: nameForReport,
      recordId: selectedItem?.id || 0,
      AppScreenId: Pages?.globalSearch?.id
    };
    dispatch(setShowReport(reportObj));
  };
  const handleShowMoreTrades = () => {
    setInitialViewMore(false);
    setDisplayedTradeCount(tradeList.length);
  };

  const handleShowLessTrades = () => {
    setInitialViewMore(true);
    if (isSmallScreen) {
      setDisplayedTradeCount(5);
    } else {
      setDisplayedTradeCount(10);
    }
  };

  const renderList = (type, title, data) => {
    const handleMoreClick = (event, item) => {
      setAnchorEl(event.currentTarget);
      setSelectedItem(item); // Store the selected item (optional, based on usage)
    };
    return (
      <Box>
        <Stack spacing={1}>
          <Typography>{title}</Typography>
          {data?.map((item, index) => (
            <Card className="pagelist-content" key={item?.id || index.toString()}>
              <ListItem
                secondaryAction={
                  <IconButton onClick={(event) => handleMoreClick(event, item)}>
                    <MoreIcon />
                  </IconButton>
                }
                disablePadding>
                <ListItemButton
                  onClick={(e) => {
                    onItemClick(type, item);
                  }}>
                  <ListItemText
                    style={{ fontSize: "15px" }}
                    primary={item?.description1}
                    secondary={item?.description2}
                  />
                </ListItemButton>
              </ListItem>
            </Card>
          ))}
          {type !== "projects" && (
            <Button
              variant="text"
              fullWidth
              onClick={() => {
                onShowMoreClick(type);
              }}>
              {BUTTON_SHOW_MORE}
            </Button>
          )}
        </Stack>
      </Box>
    );
  };

  return (
    <Box className="main-content-Box" sx={{ p: isSmallScreen ? 2 : 3 }}>
      <Card className="main-content-card" sx={{ mt: 0 }}>
        <Box className="main-content-card-list">
          <Container sx={{ padding: "0px" }} maxWidth="md">
            {showTradeLoading ? (
              <Box className="main-content-Box" sx={{ display: "flex", justifyContent: "center" }}>
                {" "}
                <Loader />{" "}
              </Box>
            ) : (
              <Stack spacing={1.5} mb={0.5}>
                <Typography>{TEXT_TYPE}</Typography>
                <Stack spacing={1.5} direction={"row"}>
                  {typeList.map((item, index) => {
                    return (
                      <Button
                        size="large"
                        key={item?.id || index.toString()}
                        label={item?.forTranlate}
                        variant={"contained"}
                        sx={{
                          alignItems: "center",
                          border: "1px solid rgb(216 216 216)",
                          boxShadow: "none",
                          textTransform: "none",
                          p: "10px 20px",
                          width: "100%",
                          color: BIBlue,
                          backgroundColor: item?.checked ? BIYellow : "white"
                        }}
                        onClick={(e) => onTypeChange(index)}
                        startIcon={
                          item.itemRecordType === "product" || item.itemRecordType === "trade" ? (
                            <BuildIcon sx={{ color: BIBlue }} />
                          ) : (
                            <BusinessCenterIcon sx={{ color: BIBlue }} />
                          )
                        }>
                        {" "}
                        {item?.text}{" "}
                      </Button>
                    );
                  })}
                </Stack>

                <Card className="pagelist-content" sx={{ marginTop: "0px" }}>
                  <ListItem
                    sx={{ m: 0 }}
                    disablePadding
                    secondaryAction={
                      <Stack direction={"row"} spacing={1} alignItems={"center"}>
                        <IconButton onClick={() => setIsExpanded(!isExpanded)}>
                          {isExpanded ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                        </IconButton>
                      </Stack>
                    }>
                    <ListItemButton onClick={() => setIsExpanded(!isExpanded)}>
                      <ListItemText primary={TEXT_ADVANCED} />
                    </ListItemButton>
                  </ListItem>
                  {isExpanded && (
                    <Stack spacing={1.5} p={2} pt={{ xs: 0, sm: 1 }}>
                      <GooglePlacesAutocomplete
                        onPlaceChanged={handleSearch}
                        onLoad={(newInstance) => {
                          setAutocomplete(newInstance);
                        }}
                        types={["(cities)"]}
                        options={{
                          componentRestrictions: { country: ["US", "CA", "GB"] } // Restrict to USA, Canada, and UK
                        }}>
                        <TextField
                          variant="outlined"
                          placeholder={TEXT_LOCATION_TYPE_HERE_PLACEHOLDER}
                          size="small"
                          fullWidth
                          // className="search-place"
                          value={address}
                          onChange={(event) => {
                            let inputValue = event.target.value;
                            inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
                            setAddress(inputValue);
                          }}
                          InputProps={{
                            style: {
                              border: "none"
                            },
                            endAdornment: (
                              <InputAdornment position="end">
                                {address !== "" && (
                                  <IconButton
                                    onClick={() => {
                                      setAddress("");
                                    }}>
                                    <CloseIcon />
                                  </IconButton>
                                )}
                              </InputAdornment>
                            )
                          }}
                        />
                      </GooglePlacesAutocomplete>
                      <Stack>{TEXT_QUICK_LOCATION}</Stack>
                      <Stack sx={{ display: "flex", flexWrap: "wrap", gap: 1 }} direction="row">
                        {userCity?.city && (
                          <Chip
                            size="medium"
                            label={userCity?.city}
                            onClick={() => onCurrentCityClick()}
                            sx={{
                              backgroundColor: userCity?.checked && BIYellow,
                              cursor: "pointer",
                              "&:hover": {
                                backgroundColor: userCity?.checked && "#dba003" // light hover for unselected
                              }
                            }}
                          />
                        )}
                        {selectCity?.map((item, index) => {
                          return (
                            <Chip
                              size="medium"
                              key={item?.id || index.toString()}
                              label={item?.city}
                              onClick={() => onCityClick(index)}
                              sx={{
                                backgroundColor: item?.checked && BIYellow,
                                cursor: "pointer",
                                "&:hover": {
                                  backgroundColor: item?.checked && "#dba003" // light hover for unselected
                                }
                              }}
                            />
                          );
                        })}
                      </Stack>
                      <Divider />
                      <Stack sx={{ display: "flex", flexWrap: "wrap", gap: 1 }} direction="row">
                        {tradeList?.slice(0, displayedTradeCount)?.map((item, index) => {
                          return (
                            <Chip
                              size="medium"
                              key={item?.id || index.toString()}
                              label={item.name.length > 30 ? item.name?.trim() : item.name?.trim()}
                              onClick={(e) => onTradeClick(index)}
                              sx={{
                                backgroundColor: item?.checked && BIYellow,
                                cursor: "pointer",
                                "&:hover": {
                                  backgroundColor: item?.checked && "#dba003" // light hover for unselected
                                }
                              }}
                            />
                          );
                        })}
                        {tradeList.length > 10 && (
                          <Button
                            style={{ borderRadius: "50px" }}
                            size="small"
                            variant="text"
                            onClick={initialViewMore ? handleShowMoreTrades : handleShowLessTrades}>
                            {initialViewMore ? TEXT_SHOW_MORE_TRADES : TEXT_SHOW_LESS_TRADES}
                          </Button>
                        )}
                      </Stack>
                    </Stack>
                  )}
                </Card>

                <Card className="pagelist-content" sx={{ p: 2 }}>
                  {loading ? (
                    <Loader />
                  ) : !isGlobalSearchDataEmpty() ? (
                    <>
                      {data?.product?.length !== 0 &&
                        renderList("product", TEXT_PRODUCTS, data?.product)}
                      {data?.manufacture?.length !== 0 &&
                        renderList("manufacturer", TEXT_MANUFACTURERS, data?.manufacture)}
                      {data?.company?.length !== 0 &&
                        renderList("company", TEXT_COMPANIES, data?.company)}
                      {data?.trade?.length !== 0 && renderList("trade", TEXT_TRADES, data?.trade)}
                      {data?.sites?.length !== 0 && renderList("sites", TEXT_SITES, data?.sites)}
                      {data?.projects?.length !== 0 &&
                        renderList("projects", TEXT_PROJECTS, data?.projects)}
                    </>
                  ) : (
                    <Box className="empty-data-card">
                      <Emptydata firstText={TEXT_NO_RESULTS_FOUND} />
                    </Box>
                  )}

                  {Boolean(anchorEl) && (
                    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
                      <MenuItem onClick={handleReportClick} sx={{ color: BIRed }}>
                        {BUTTON_REPORT}
                      </MenuItem>
                    </Menu>
                  )}
                </Card>
              </Stack>
            )}
          </Container>
        </Box>
      </Card>
    </Box>
  );
};

export default Search;
